// extracted by mini-css-extract-plugin
export default {"hideTooltip":"n--z","fadeIn":"o--z","delay":"p--z","recommendedSizeTooltip":"q--z"};